import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import { showDangerToast } from '../../constants/toaster'
import { useState } from 'react'
import { s3 } from '../../constants/awsConfig'
import { useDispatch } from 'react-redux'
import { updateLoading } from '../../../redux/features/common/commonSlice'
export const AddBusinessCategory = props => {
  const [isChangeStarted, setisChangeStarted] = useState(false);
  const [imageFileData, setImageFileData] = useState(null)
  const dispatch = useDispatch();
  const handleSubmit = async () => {
    if (props?.tagFormData?.uuid) {
      if (props?.tagFormData?.categoryName) {
        if (imageFileData) {
          dispatch(updateLoading(true))
          const uploadedFile = await uploadImageFile(imageFileData)
          dispatch(updateLoading(false))
          props?.onSubmit(uploadedFile)
        }
        props?.onSubmit()
      } else {
        showDangerToast("Name is requried.")
      }

    } else {
      if (props?.tagFormData?.categoryName) {
        if (imageFileData) {
          dispatch(updateLoading(true))
          const uploadedFile = await uploadImageFile(imageFileData)
          dispatch(updateLoading(false))
          props?.setTagFormData({
            ...props?.tagFormData,
            categoryImage: uploadedFile
          })
          props?.onSubmit(uploadedFile)
        } else {
          showDangerToast("Icon is requried.")
        }

      } else {
        showDangerToast('Category name is required.')
      }


    }
  }



  const uploadImageFile = async assetFile => {
    if (!assetFile) return;

    const params = {
      Bucket: 'supa-dev-bucket', // bucket name
      Key: `uploads/${assetFile.name}`,
      Body: assetFile,
      ContentType: assetFile.type,
      // ACL: 'public-read', // Adjust according to your needs
    };

    try {
      const data = await s3.upload(params).promise();
      console.log('Upload Success', data.Location);
      const url = data.Location.replace(
        "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
        "https://d2up68x544gew2.cloudfront.net/"
      );
      console.log(url, 'url');
      return url
    } catch (error) {
      console.error('Error uploading file:', error);
      return ''
    }
  }

  const handleTagName = (e) => {
    // let value = e.target.value.replace(/\s{2,}/g, ' ').trim();
    setisChangeStarted(true);
    props.setTagFormData({
      ...props?.tagFormData,
      categoryName: e.target.value
    });
  };

  const handleImageSelect = event => {
    const file = event.target.files[0]
    setImageFileData(file)
  }


  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header>
        <Modal.Title id='contained-modal-title-vcenter'>
          {props?.tagFormData?.uuid ? 'Update Business Category' : 'Add Business Category'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <div className="row">
          <div className="col-md-6">
            <Form.Control
              value={props.tagFormData.categoryName}
              onChange={e => handleTagName(e)}
              placeholder='Enter Category Name'
              maxLength={75}
              aria-label='Small'
              aria-describedby='inputGroup-sizing-sm'
            />
            {props?.tagFormData?.categoryName ? (
              <></>
            ) : (
              <>
                {isChangeStarted && <label className='custom-error-label'>Category Name is required*</label>}
              </>
            )}
          </div>
          <div className='col-md-6'>
            <input type='file' accept={'image/*'} onChange={(event) => handleImageSelect(event)} />
          </div>

        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button variant='outlined' onClick={() => {
          setisChangeStarted(false);
          props.onHide();
        }}>
          Cancel
        </Button>
        <Button onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  )
}
